import { render, staticRenderFns } from "./AppBal.vue?vue&type=template&id=12910035&"
import script from "./AppBal.vue?vue&type=script&lang=js&"
export * from "./AppBal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports